import { Component, Input, EventEmitter, Output } from '@angular/core';
import { CreatorStep } from '../creator.component';
import { NgClass } from '@angular/common';
import { ValidationAreaComponent } from '../../validation/validation-area/validation-area.component';

@Component({
    selector: 'skl-creator-timeline',
    templateUrl: './creator-timeline.component.html',
    styleUrls: ['./creator-timeline.component.scss'],
    imports: [NgClass, ValidationAreaComponent]
})
export class CreatorTimelineComponent {

    @Input() public steps!: CreatorStep[];

    @Input() public currentStep!: CreatorStep;

    @Output() public onStepChange = new EventEmitter<CreatorStep>();

    public isStepActive(step: CreatorStep): boolean {
        return (step.id === this.currentStep.id) || (!!step.active && step.id !== this.currentStep.id);
    }

    public isStepMarked(step: CreatorStep): boolean {
        return !!step.active && step.id !== this.currentStep.id;
    }

    public changeStep(step: CreatorStep): void {
        if (step.active) this.onStepChange.emit(step);
    }
}
